// extracted by mini-css-extract-plugin
module.exports = {"carousel":"style-module--carousel--33cxL","carousel__slider":"style-module--carousel__slider--QOgQy","carousel__item":"style-module--carousel__item--3BS2D"};